// src/components/Category.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const Category = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const response = await axios.get('http://161.97.115.122:5000/kategorie');
        setCategories(response.data);
      } catch (error) {
        console.error("Błąd podczas pobierania kategorii:", error);
      }
    }

    fetchCategories();
  }, []);

  return (
  <div className="app-container">
    <div className="sidebar">
     <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />

  <div className="menu">
 
    <ul>
          <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>

    </ul>
</div>
    </div>
    <div className="content">
    <div className="katalog">
<h1>Kategorie</h1>
      <ul>
  {categories
  .filter(category => category.nazwa.length >= 3)
  .map(category => (
 
    
    
      <li key={category._id} className="type-item">
          <div className="type-image">
            <img src={`http://161.97.115.122:5000/${category.imagePath}`} alt={category.nazwa} />
          </div>
          <div className="type-info">
          <Link to={`/type/${category._id}`} className="type-link">
         {category.nazwa.length >= 3 ? category.nazwa : null}
</Link>

          </div>
        </li>
  ))}
</ul>
    </div>
    </div>
    </div>
  );
}

export default Category;
